import { Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import styled from "styled-components";

import { colors, types } from "../../../../libs";

export const GenerateModal = styled(Modal)`
  .manual-billing-modal {
    max-width: min(1120px, calc(100vw - 32px));
  }

  .modal-content {
    background: ${colors.background.lightBlack};
    border: 1px solid rgba(255, 255, 255, 0.13);
    border-radius: 16px;
    max-height: calc(100vh - 42px);
    overflow: hidden;
  }
`;

export const ModalWrapper = styled.div`
  background:
    radial-gradient(circle at 96% 2%, rgba(183, 248, 77, 0.09), transparent 26%),
    ${colors.background.lightBlack};
  display: grid;
  gap: 18px;
  max-height: calc(100vh - 42px);
  overflow-y: auto;
  padding: 26px;
`;

export const HeaderRow = styled.div`
  align-items: center;
  display: flex;
  gap: 20px;
  justify-content: space-between;
`;

export const HeaderActions = styled.div`
  align-items: center;
  display: flex;
  gap: 10px;
`;

export const CloseButton = styled.button`
  align-items: center;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 50%;
  color: ${colors.text.white};
  cursor: pointer;
  display: inline-flex;
  font-size: 22px;
  height: 36px;
  justify-content: center;
  line-height: 1;
  padding: 0 0 2px;
  width: 36px;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

export const ModalTitle = styled.div`
  ${types.body.secondaryTitle}
  color: ${colors.text.white};
  font-size: 25px;
  font-weight: 750;
`;

export const ModalSubtitle = styled.div`
  ${types.body.normal}
  color: ${colors.text.gray};
  margin-top: 4px;
`;

export const ModeBadge = styled.span<{ $manual: boolean }>`
  background: ${({ $manual }) => ($manual ? "rgba(183, 248, 77, 0.1)" : "rgba(99, 169, 255, 0.1)")};
  border: 1px solid
    ${({ $manual }) => ($manual ? "rgba(183, 248, 77, 0.42)" : "rgba(99, 169, 255, 0.42)")};
  border-radius: 2px;
  color: ${({ $manual }) => ($manual ? colors.text.green : "#8cc2ff")};
  font-size: 12px;
  font-weight: 700;
  padding: 7px 11px;
`;

export const LoadingState = styled.div`
  align-items: center;
  color: ${colors.text.gray};
  display: flex;
  gap: 10px;
  justify-content: center;
  min-height: 240px;
`;

export const Section = styled.section`
  background: rgba(255, 255, 255, 0.025);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  display: grid;
  gap: 14px;
  padding: 18px;
`;

export const SectionTitle = styled.h3`
  color: ${colors.text.white};
  font-size: 17px;
  margin: 0;
`;

export const FieldGrid = styled.div`
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }
`;

export const DatePickerWrapper = styled.div`
  background: ${colors.background.formField};
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const DatePickerLabel = styled.div`
  ${types.body.normal}
  color: ${colors.text.white};
  opacity: 0.45;
  padding: 5px 15px 0;
`;

export const CustomDatePicker = styled(DatePicker)`
  background: #1e2025;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  color: #fff;
  outline: none;
  padding: 12px 15px;
  width: 100%;
`;

export const Summary = styled.div`
  background: rgba(183, 248, 77, 0.055);
  border: 1px solid rgba(183, 248, 77, 0.25);
  border-radius: 9px;
  color: ${colors.text.lightGray};
  display: grid;
  font-size: 13px;
  gap: 6px;
  line-height: 1.5;
  padding: 14px;

  strong {
    color: ${colors.text.green};
    text-transform: uppercase;
  }
`;

export const ConfirmWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;
  justify-content: space-between;
`;

export const ConfirmText = styled.div`
  ${types.body.label}
  color: ${colors.text.lightGray};
`;

export const ActionRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-end;
`;

export const HistoryTableWrapper = styled.div`
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 9px;
  max-height: 320px;
  overflow: auto;
`;

export const HistoryTable = styled.table`
  border-collapse: collapse;
  color: ${colors.text.lightGray};
  font-size: 12px;
  min-width: 780px;
  width: 100%;

  th,
  td {
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    padding: 12px 14px;
    text-align: left;
  }

  th {
    color: ${colors.text.gray};
    font-size: 10px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  small {
    color: ${colors.text.gray};
    display: block;
    margin-top: 3px;
  }

  a {
    color: ${colors.text.green};
  }
`;

export const EmptyHistory = styled.div`
  color: ${colors.text.gray};
  font-size: 13px;
  padding: 12px 0;
`;
